var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid--container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col--centered",style:(`max-width: ${_vm.maxWidth}`)},[_c('Card',[_c('CardText',{staticClass:"card__text--padded"},[_vm._t("default")],2),_vm._v(" "),_vm._t("actions")],2),_vm._v(" "),_vm._t("after")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }